import { useCallback, useState } from "react";

export type DocumentViewMode = "grid" | "list";

export const DOCUMENT_VIEW_MODE_STORAGE_KEY = "workith-document-view-mode";

export function isDocumentViewMode(value: unknown): value is DocumentViewMode {
  return value === "grid" || value === "list";
}

function readStoredDocumentViewMode(): DocumentViewMode {
  if (typeof window === "undefined") {
    return "grid";
  }

  try {
    const storedValue = window.localStorage.getItem(DOCUMENT_VIEW_MODE_STORAGE_KEY);
    return isDocumentViewMode(storedValue) ? storedValue : "grid";
  } catch {
    return "grid";
  }
}

export function useDocumentViewMode(): [
  DocumentViewMode,
  (nextViewMode: DocumentViewMode) => void,
] {
  const [viewMode, setViewModeState] = useState<DocumentViewMode>(readStoredDocumentViewMode);

  const setViewMode = useCallback((nextViewMode: DocumentViewMode) => {
    setViewModeState(nextViewMode);

    try {
      window.localStorage.setItem(DOCUMENT_VIEW_MODE_STORAGE_KEY, nextViewMode);
    } catch {
      // Keep the in-memory selection even when browser storage is unavailable.
    }
  }, []);

  return [viewMode, setViewMode];
}
